import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.css";
import { FaBus, FaMapMarkedAlt, FaMoneyBillWave } from "react-icons/fa";
import publicApi from "../api/publicApi";


const Home = () => {
  const navigate = useNavigate();

  const [origen, setOrigen]       = useState('');
  const [destino, setDestino]     = useState('');
  const [fecha, setFecha]         = useState('');
  const [terminales, setTerminales] = useState([]);

  useEffect(() => {
    const fetchTerminals = async () => {
      try {
        const response = await publicApi.get("/list_terminal");
        setTerminales(response.data || []);
      } catch (err) {
        console.error('Error cargando terminales:', err);
      }
    };
    fetchTerminals();
  }, []);

  const handleSearch = () => {
    navigate(`/busroutes?origen=${origen}&destino=${destino}&fecha=${fecha}`);
  };

  return (
    <div className={styles.home}>

      {/* ── HERO ── */}
      <section
        className={styles.heroSection}
        style={{ backgroundImage: "url('/bus1.jpg')" }}
      >
        <div className={styles.overlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.title}>Viaja por Venezuela<br />con confianza</h1>
          <p className={styles.subtitle}>
            Reserva tu pasaje en línea, elige tu asiento y viaja con comodidad
            a cualquier rincón del país.
          </p>

          {/* Barra de búsqueda */}
          <div className={styles.searchCard}>
            <div className={styles.searchFields}>
              <div className={styles.searchField}>
                <label className={styles.searchLabel}>Origen</label>
                <select
                  value={origen}
                  onChange={e => setOrigen(e.target.value)}
                  className={styles.searchSelect}
                >
                  <option value="">Selecciona terminal</option>
                  {terminales.filter(t => t.name !== destino).map(t => (
                    <option key={`o-${t.id}`} value={t.name}>{t.name}</option>
                  ))}
                </select>
              </div>

              <div className={styles.searchDivider} aria-hidden="true">→</div>

              <div className={styles.searchField}>
                <label className={styles.searchLabel}>Destino</label>
                <select
                  value={destino}
                  onChange={e => setDestino(e.target.value)}
                  className={styles.searchSelect}
                >
                  <option value="">Selecciona terminal</option>
                  {terminales.filter(t => t.name !== origen).map(t => (
                    <option key={`d-${t.id}`} value={t.name}>{t.name}</option>
                  ))}
                </select>
              </div>

              <div className={styles.searchField}>
                <label className={styles.searchLabel}>Fecha de viaje</label>
                <input
                  type="date"
                  value={fecha}
                  onChange={e => setFecha(e.target.value)}
                  min={new Date().toISOString().split('T')[0]}
                  className={styles.searchInput}
                />
              </div>
            </div>

            <button onClick={handleSearch} className={styles.searchButton}>
              Buscar rutas
            </button>
          </div>

          {/* Acciones de cuenta */}
          <div className={styles.authRow}>
            <span className={styles.authText}>¿Ya tienes cuenta?</span>
            <button onClick={() => navigate("/login")} className={styles.btnGhost}>
              Iniciar sesión
            </button>
            <span className={styles.authSep} aria-hidden="true">·</span>
            <button onClick={() => navigate("/register")} className={styles.btnWhite}>
              Registrarse
            </button>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className={styles.featuresSection}>
        <div className={styles.featuresInner}>
          <div className={styles.featureItem}>
            <div className={styles.featureIcon} aria-hidden="true">
              <FaBus />
            </div>
            <div className={styles.featureText}>
              <h3>Flota moderna</h3>
              <p>Unidades climatizadas, reclinables y con seguimiento GPS en tiempo real.</p>
            </div>
          </div>

          <div className={styles.featureDivider} aria-hidden="true" />

          <div className={styles.featureItem}>
            <div className={styles.featureIcon} aria-hidden="true">
              <FaMapMarkedAlt />
            </div>
            <div className={styles.featureText}>
              <h3>Cobertura nacional</h3>
              <p>Más de 20 rutas activas que conectan los principales destinos del país.</p>
            </div>
          </div>

          <div className={styles.featureDivider} aria-hidden="true" />

          <div className={styles.featureItem}>
            <div className={styles.featureIcon} aria-hidden="true">
              <FaMoneyBillWave />
            </div>
            <div className={styles.featureText}>
              <h3>Tarifas accesibles</h3>
              <p>Precios transparentes, sin cargos ocultos. Paga en línea de forma segura.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <span className={styles.footerLogo}>Flamingo</span>
            <p className={styles.footerTagline}>
              Conectando Venezuela desde 2020.
            </p>
          </div>

          <div className={styles.footerSection}>
            <h4 className={styles.footerHeading}>Contacto</h4>
            <p>expresosflamingo@gmail.com</p>
            <p>+58 Esta pagina aun no esta en funcionamiento</p>
          </div>

          <div className={styles.footerSection}>
            <h4 className={styles.footerHeading}>Legal</h4>
            <p>Términos y Condiciones</p>
            <p>Política de Privacidad</p>
            <p>Empleados</p>
          </div>

          <div className={styles.footerSection}>
            <h4 className={styles.footerHeading}>Síguenos</h4>
            <div className={styles.socialIcons}>
              <i className="fab fa-facebook-f" aria-label="Facebook" />
              <i className="fab fa-twitter" aria-label="Twitter" />
              <i className="fab fa-instagram" aria-label="Instagram" />
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <span>© {new Date().getFullYear()} Expresos Flamingo. Todos los derechos reservados.</span>
        </div>
      </footer>
    </div>
  );
};

export default Home;
